<div class="flex flex-col gap-4" data-cy="medical-conditions">
  <h3 class="medical-section-title text-lg font-semibold m-0">{{ 'animalMedical.sections.conditions' | transloco }}</h3>

  <!-- Aktueller Zustand -->
  <div class="grid grid-cols-1 md:grid-cols-3 gap-3">
    <div class="border border-gray-200 rounded-lg p-3 flex flex-col gap-1">
      <span class="text-xs text-gray-500">{{ 'bcs.nutrition.title' | transloco }}</span>
      @if (animal?.currentBcsNutrition?.value; as value) {
        <span class="font-semibold">{{ (nutritionLabel(value) ?? value) | transloco }}</span>
        <span class="text-xs text-gray-500">
          {{ animal?.currentBcsNutrition?.observedAt | date:'dd.MM.yyyy' }} ·
          @if (animal?.currentBcsNutrition?.source === 'medical_record' && animal?.currentBcsNutrition?.sourceId) {
            <a class="cursor-pointer text-[var(--p-primary-700)] hover:underline" (click)="goToRecord.emit(animal!.currentBcsNutrition!.sourceId!)">
              {{ 'animalMedical.recordLink' | transloco: { id: animal?.currentBcsNutrition?.sourceId } }}
            </a>
          } @else {
            {{ sourceLabelKey(animal?.currentBcsNutrition?.source) | transloco }}
          }
        </span>
      } @else {
        <span class="text-gray-500">–</span>
      }
    </div>

    <div class="border border-gray-200 rounded-lg p-3 flex flex-col gap-1">
      <span class="text-xs text-gray-500">{{ 'bcs.care.title' | transloco }}</span>
      @if (animal?.currentCareCondition?.values?.length) {
        <span class="font-semibold">
          @for (label of careLabels(animal?.currentCareCondition?.values); track label; let last = $last) {
            {{ label | transloco }}@if (!last) {, }
          }
        </span>
        <span class="text-xs text-gray-500">
          {{ animal?.currentCareCondition?.observedAt | date:'dd.MM.yyyy' }} ·
          @if (animal?.currentCareCondition?.source === 'medical_record' && animal?.currentCareCondition?.sourceId) {
            <a class="cursor-pointer text-[var(--p-primary-700)] hover:underline" (click)="goToRecord.emit(animal!.currentCareCondition!.sourceId!)">
              {{ 'animalMedical.recordLink' | transloco: { id: animal?.currentCareCondition?.sourceId } }}
            </a>
          } @else {
            {{ sourceLabelKey(animal?.currentCareCondition?.source) | transloco }}
          }
        </span>
      } @else {
        <span class="text-gray-500">–</span>
      }
    </div>

    <div class="border border-gray-200 rounded-lg p-3 flex flex-col gap-1">
      <span class="text-xs text-gray-500">{{ 'animalMedical.fields.weight' | transloco }}</span>
      @if (animal?.weight) {
        <span class="font-semibold">{{ gramsToKg(animal!.weight) | number:'1.0-3' }} kg</span>
        @if (weightTrend) {
          <span class="text-xs"
                [ngClass]="weightTrend.deltaKg > 0 ? 'text-orange-600' : weightTrend.deltaKg < 0 ? 'text-blue-600' : 'text-gray-500'">
            {{ weightTrend.deltaKg > 0 ? '+' : '' }}{{ weightTrend.deltaKg | number:'1.0-3' }} kg
            {{ 'animalMedical.conditions.weightSince' | transloco: { date: (weightTrend.since | date:'dd.MM.yyyy') } }}
          </span>
        }
      } @else {
        <span class="text-gray-500">–</span>
      }
    </div>
  </div>

  <!-- Diagnosen -->
  @if (!conditions.length) {
    <p-message severity="info">{{ 'animalMedical.conditions.empty' | transloco }}</p-message>
  }
  <div class="grid gap-3 grid-cols-[repeat(auto-fill,minmax(20rem,1fr))]">
    @for (condition of conditions; track condition.id) {
      <article class="border rounded-lg p-3 flex flex-col gap-2"
               [ngClass]="condition.resolvedAt ? 'border-gray-200 opacity-70' : 'border-[var(--p-primary-200)]'">
        <div class="flex flex-wrap items-center gap-2">
          <p-tag severity="secondary" [value]="kindLabelKey(condition.kind) | transloco" />
          <p-tag [severity]="condition.resolvedAt ? 'secondary' : 'success'"
                 [value]="(condition.resolvedAt ? 'animalMedical.conditions.resolved' : 'animalMedical.conditions.active') | transloco" />
          @if (condition.severity) {
            <p-tag [severity]="severityClass(condition.severity)" [value]="severityLabelKey(condition.severity) | transloco" />
          }
          @if (condition.visibleToAdopter) {
            <p-tag severity="warn" icon="pi pi-eye" [value]="'animalMedical.fields.visibleToAdopterShort' | transloco" />
          }
        </div>
        <span class="font-semibold">{{ condition.label }}</span>
        <div class="flex flex-wrap gap-x-4 gap-y-1 text-xs text-gray-600">
          <span>{{ 'animalMedical.fields.diagnosedAt' | transloco }}: {{ condition.diagnosedAt ? (condition.diagnosedAt | date:'dd.MM.yyyy') : '–' }}</span>
          @if (condition.resolvedAt) {
            <span>{{ 'animalMedical.fields.resolvedAt' | transloco }}: {{ condition.resolvedAt | date:'dd.MM.yyyy' }}</span>
          }
        </div>
        @if (condition.notes) {
          <span class="text-sm whitespace-pre-line">{{ condition.notes }}</span>
        }
        @if (refId(condition.diagnosedByRecord); as recordId) {
          <a class="text-xs cursor-pointer text-[var(--p-primary-700)] hover:underline self-start" (click)="goToRecord.emit(recordId)">
            {{ 'animalMedical.recordLink' | transloco: { id: recordId } }}
          </a>
        }
      </article>
    }
  </div>
</div>
